// these domains do not need to be verified, they are public providers

export const PUBLIC_DOMAINS = [
    'gmail.com', 'googlemail.com',
    'yahoo.com', 'yahoo.ca', 'yahoo.fr', 'yahoo.co.uk',
    'hotmail.com', 'hotmail.ca', 'hotmail.fr', 'hotmail.co.uk',
    'outlook.com', 'outlook.ca', 'outlook.fr',
    'live.com', 'live.ca', 'live.fr',
    'aol.com', 'msn.com',
    'icloud.com', 'me.com', 'mac.com'
]

// helps persist state for search and sort
export const SEARCH_AND_SORT_STORAGE_KEY = "senders_listing_state"